import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Row,
  Col,
  Input
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';
import TextInput from '../../../shared/components/TextInput';

class AgencyManageAccoutInfo extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null,
      isSaving:false,
      validationMessages:{}
    };
  }

  handleSubmit(data){
    this.setState({isSaving:true});
    this.props.updateAgency(this.props.agency.id,{
      name:data.name,
      websiteUrl:data.websiteUrl
    })
      .then(() => this.setState({isSaving:false}))
  }

  render(){
    const { isSaving, validationMessages } = this.state;

    const { agency } = this.props;

    return (
      <div className='AgencyManageAccoutInfo'>
        <Row>
          <Col md='6' xs='12'>
            <Form onSubmit={(data) => this.handleSubmit(data)}>
              <TextInput 
                name='name' 
                label='Name' 
                placeholder='Acme INC'
                warning={validationMessages['name']}
                defaultValue={agency.name}
              />
              <TextInput 
                name='websiteUrl'
                label='Website URL'
                placeholder='www.acmeinc.com'
                warning={validationMessages['websiteUrl']}
                defaultValue={agency.websiteUrl}
              />
              <Button 
                isSubmit
                disabled={isSaving}
              >
                {isSaving ? 'Saving...' : 'Save'}
              </Button>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

AgencyManageAccoutInfo.propTypes = {
  //TODO: Fill in prop types for AgencyManageAccoutInfo
};

AgencyManageAccoutInfo.defaultProps = {
  //TODO: Fill in defaultProps for AgencyManageAccoutInfo
};

export default AgencyManageAccoutInfo;



// WEBPACK FOOTER //
// ./src/routes/AgencyManageAccoutInfo/components/AgencyManageAccoutInfo.js